import styled from 'styled-components'

// Guscio comune delle modali "a scheda" (overlay + contenitore centrato + header/body/footer)
export const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: ${props => props.theme.name === 'dark' ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.3)'};
  backdrop-filter: blur(2px);
  z-index: 998;
`

// $width: larghezza in px/rem (default 480px)
export const ModalContainer = styled.div`
  position: fixed;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ $width }) => $width || '480px'};
  max-width: 90vw;
  max-height: 90vh;
  overflow-y: auto;
  background: ${props => props.theme.colors.background.primary};
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  z-index: 999;
  padding: 1.5rem;
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${props => props.theme.colors.text.primary};
`

export const CloseBtn = styled.button`
  background: none;
  border: none;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  padding: 0.25rem;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s;
  opacity: ${props => props.disabled ? 0.5 : 1};

  &:hover:not(:disabled) {
    background: ${props => props.theme.colors.background.secondary};
    color: ${props => props.theme.colors.text.primary};
  }
`

// $gap: spazio tra i campi (default 1rem)
export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => $gap || '1rem'};
`

export const ModalFooter = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-top: 1.5rem;
  justify-content: flex-end;
`
